import PropTypes from 'prop-types';
import { Fragment, useState, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { OptionType } from 'UIComponents/types/OptionTypes';
import CategorySelect from 'data-token-picker/components/CategorySelect';
import { TINYMCE_PREVENT_BLUR_CLASSNAME } from 'data-token-picker/constants/TinyMCEHooks';
// @ts-expect-error TS7016, Drilldown has not yet been migrated.
import DrilldownSelect from 'data-token-picker/components/DrilldownSelect';
import { PropertyCategories } from 'data-token-picker/constants/Properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserBodyPropTypes = {
  className: PropTypes.string,
  field: PropTypes.string,
  fields: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  onEdit: PropTypes.func.isRequired,
  category: PropTypes.string,
  categories: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  settingsLink: PropTypes.string
};
const BrowserBody = ({
  onEdit,
  category,
  categories,
  field,
  fields,
  settingsLink
}) => {
  const [categoryLabel, setCategoryLabel] = useState();
  useEffect(() => {
    const findCurrent = categoryNode => {
      if (categoryNode.value === category) {
        setCategoryLabel(categoryNode.text);
        return true;
      }
      if (categoryNode.options) {
        categoryNode.options.some(findCurrent);
      }
      return false;
    };
    if (categories) {
      categories.some(findCurrent);
    }
  }, [category, categories]);
  const handleEditType = evt => {
    onEdit({
      category: evt.target.value
    });
  };
  const handleEditField = evt => {
    onEdit({
      category,
      fieldOption: evt.target.value
    });
  };
  let categoryHelpLink;
  if (category === PropertyCategories.SITE_SETTINGS && settingsLink) {
    categoryHelpLink = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "data-token-picker.typeHelp.editOfficeSettingsLink",
      options: {
        href: settingsLink
      }
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "data-token-picker.typeLabel"
      }),
      help: categoryHelpLink,
      children: /*#__PURE__*/_jsx(CategorySelect, {
        onChange: handleEditType,
        options: categories,
        value: category
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "data-token-picker.fieldLabel"
      }),
      children: /*#__PURE__*/_jsx(DrilldownSelect, {
        "data-test-id": "token-field-select",
        searchClassName: `${TINYMCE_PREVENT_BLUR_CLASSNAME} token-field-search`,
        onChange: handleEditField,
        options: fields,
        value: field,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "data-token-picker.fieldPlaceholder"
        }),
        rootBreadcrumb: categoryLabel
      }, category)
    })]
  });
};
BrowserBody.propTypes = BrowserBodyPropTypes;
BrowserBody.displayName = 'BrowserBody';
export default BrowserBody;